export default {
  'pages.flexibleSingleImport.title': 'Flexible single-sales workbook import',
  'pages.flexibleSingleImport.info.message': 'New import flow',
  'pages.flexibleSingleImport.info.description':
    'The file is staged first. Review each sheet, decide whether to import it, and align its fields manually. Existing upload APIs are not used.',
  'pages.flexibleSingleImport.upload.button': 'Select and configure workbook',
  'pages.flexibleSingleImport.upload.failed': 'File upload failed',
  'pages.flexibleSingleImport.upload.staged':
    'The file is staged. Please review each sheet and its import settings.',
  'pages.flexibleSingleImport.modal.title': 'Import configuration: {fileName}',
  'pages.flexibleSingleImport.modal.titleFallback': 'Import configuration',
  'pages.flexibleSingleImport.step.sheets': 'Sheets and data range',
  'pages.flexibleSingleImport.step.mapping': 'Field mapping',
  'pages.flexibleSingleImport.step.sheetWizard': 'Review sheets one by one',
  'pages.flexibleSingleImport.step.preview': 'Preview and validation',
  'pages.flexibleSingleImport.step.result': 'Import result',
  'pages.flexibleSingleImport.sheet.export': 'Export',
  'pages.flexibleSingleImport.sheet.exportCurrent': 'Export this sheet',
  'pages.flexibleSingleImport.sheet.headerAction': 'Header action',
  'pages.flexibleSingleImport.sheet.currentHeader': 'Current header',
  'pages.flexibleSingleImport.sheet.useAsHeader': 'Use as header',
  'pages.flexibleSingleImport.sheet.importStepTitle':
    'Step 1 · Decide whether to import this sheet',
  'pages.flexibleSingleImport.sheet.exportStepTitle':
    'Step 1 · Decide whether to export this sheet',
  'pages.flexibleSingleImport.sheet.exportOnDescription':
    'Export is enabled. After confirmation, this sheet will participate in royalty statistics.',
  'pages.flexibleSingleImport.sheet.exportOffDescription':
    'Export is disabled. Review the content first, then turn on the switch if it should be counted.',
  'pages.flexibleSingleImport.sheet.exportOn': 'Export this sheet',
  'pages.flexibleSingleImport.sheet.exportOff': 'Do not export',
  'pages.flexibleSingleImport.sheet.exportSwitch': 'Export',
  'pages.flexibleSingleImport.sheet.skip': 'Skip',
  'pages.flexibleSingleImport.sheet.tableTitle': 'Sheet content and field alignment',
  'pages.flexibleSingleImport.sheet.dataRule':
    'Data starts immediately after the selected header; the rest of the non-empty sheet is scanned automatically.',
  'pages.flexibleSingleImport.sheet.chooseHeaderFirst':
    'Choose the row containing the real column names first.',
  'pages.flexibleSingleImport.sheet.exportMessage':
    'This sheet will be validated and exported to the royalty statistics after confirmation.',
  'pages.flexibleSingleImport.sheet.excludedMessage':
    'This sheet is currently not exported. You can still review it and turn on export at any time.',
  'pages.flexibleSingleImport.sheet.navigationDescription':
    'Complete the four sections in order: decide export, find the header and map fields, check excluded rows, then fill unmatched required fields.',
  'pages.flexibleSingleImport.sheet.previewStepTitle': 'Step 1 · Review the first rows',
  'pages.flexibleSingleImport.sheet.previewStepDescription':
    'Check whether this is the detail sheet to count, then decide whether to import it.',
  'pages.flexibleSingleImport.sheet.importMessage':
    'Review the sample, then decide whether to import this sheet.',
  'pages.flexibleSingleImport.sheet.notImportMessage':
    'This sheet is marked not to import. Use the button below to continue.',
  'pages.flexibleSingleImport.sheet.completedImport':
    'Step 1 completed: this sheet will be imported',
  'pages.flexibleSingleImport.sheet.completedMapping':
    'Step 2 completed: row {row} is the header; {count} fields mapped',
  'pages.flexibleSingleImport.sheet.completedExcluded': 'Step 3 completed: {count} rows excluded',
  'pages.flexibleSingleImport.sheet.currentStep': 'Current step: {step} / 4',
  'pages.flexibleSingleImport.sheet.mappingStepTitle':
    'Step 2 · Find the header and map statistics fields',
  'pages.flexibleSingleImport.sheet.skipMappingMessage':
    'This sheet is not exported, so header and field mapping can be skipped.',
  'pages.flexibleSingleImport.sheet.skipMappingDescription':
    'Turn on the export switch above if this sheet should be counted in the royalty statistics.',
  'pages.flexibleSingleImport.sheet.summaryTitle': 'Excluded rows',
  'pages.flexibleSingleImport.sheet.filterTitle': 'Exclusion rules',
  'pages.flexibleSingleImport.sheet.excludedStepTitle': 'Step 3 · Check the excluded rows',
  'pages.flexibleSingleImport.sheet.excludedStepDescription':
    'These rows will not be exported. Uncheck a row if it is actually a detail record.',
  'pages.flexibleSingleImport.sheet.noSummaryRows': 'There are currently no excluded rows.',
  'pages.flexibleSingleImport.sheet.excludeHint':
    'Excluded rows are shown in the check area above and can be restored at any time.',
  'pages.flexibleSingleImport.sheet.reviewProgress': 'Reviewed {current} of {total} sheets',
  'pages.flexibleSingleImport.sheet.status': 'Selection status',
  'pages.flexibleSingleImport.sheet.selected': 'Selected',
  'pages.flexibleSingleImport.sheet.pending': 'Pending',
  'pages.flexibleSingleImport.sheet.name': 'Sheet name',
  'pages.flexibleSingleImport.sheet.nonEmptyRows': 'Non-empty rows',
  'pages.flexibleSingleImport.sheet.columns': 'Columns',
  'pages.flexibleSingleImport.sheet.recommendation': 'Recommendation',
  'pages.flexibleSingleImport.sheet.recommendedDetail': 'Suggested detail',
  'pages.flexibleSingleImport.sheet.recommendedSummary': 'Suggested summary',
  'pages.flexibleSingleImport.sheet.suspiciousRows': 'Excluded rows',
  'pages.flexibleSingleImport.sheet.validRows': 'Valid data rows',
  'pages.flexibleSingleImport.sheet.pendingPreview': 'Preview pending',
  'pages.flexibleSingleImport.sheet.excludedRows': 'Currently excluded rows',
  'pages.flexibleSingleImport.sheet.configure': 'Configure',
  'pages.flexibleSingleImport.sheet.viewAdjust': 'View / adjust',
  'pages.flexibleSingleImport.sheet.selectionTitle': 'Confirm which sheets to import',
  'pages.flexibleSingleImport.sheet.selectionDescription':
    'The system does not decide the export scope from sheet order, names, or previous samples. Confirm export sheet by sheet.',
  'pages.flexibleSingleImport.sheet.selectAll': 'Export all',
  'pages.flexibleSingleImport.sheet.clearAll': 'Exclude all',
  'pages.flexibleSingleImport.sheet.selectedCount':
    '{selected} / {total} sheets selected for export',
  'pages.flexibleSingleImport.sheet.selectAtLeastOne': 'Select at least one sheet to export',
  'pages.flexibleSingleImport.dataArea.title': 'data range',
  'pages.flexibleSingleImport.dataArea.headerRow': 'Header row',
  'pages.flexibleSingleImport.dataArea.startRow': 'Data start row',
  'pages.flexibleSingleImport.dataArea.endRow': 'Data end row',
  'pages.flexibleSingleImport.dataArea.autoSummary': 'Auto-exclude summary rows',
  'pages.flexibleSingleImport.filter.keywords': 'Keywords (comma-separated)',
  'pages.flexibleSingleImport.filter.keywordsPlaceholder': 'Keywords: total, subtotal, 合计...',
  'pages.flexibleSingleImport.filter.ignoredRows': 'Ignored row numbers (comma-separated)',
  'pages.flexibleSingleImport.filter.ignoredRanges': 'Ignored row ranges (e.g. 100-105, 210-212)',
  'pages.flexibleSingleImport.filter.ignoredRangesPlaceholder': 'Leave empty to ignore no ranges',
  'pages.flexibleSingleImport.filter.checkColumns':
    'Columns checked for summary keywords (empty checks the whole row)',
  'pages.flexibleSingleImport.filter.checkColumnsPlaceholder':
    'Select columns; empty checks the whole row',
  'pages.flexibleSingleImport.sample.head': 'Data range head sample',
  'pages.flexibleSingleImport.sample.tail': 'Data range tail sample',
  'pages.flexibleSingleImport.row.number': 'Row',
  'pages.flexibleSingleImport.row.content': 'Content',
  'pages.flexibleSingleImport.row.reason': 'Handling',
  'pages.flexibleSingleImport.row.suspiciousSummary': 'Excluded row',
  'pages.flexibleSingleImport.row.excludeRestore': 'Exclude / restore',
  'pages.flexibleSingleImport.row.excluded': 'Excluded',
  'pages.flexibleSingleImport.row.keep': 'Keep',
  'pages.flexibleSingleImport.mapping.targetField': 'Target field',
  'pages.flexibleSingleImport.mapping.source': 'Source',
  'pages.flexibleSingleImport.mapping.chooseTarget': 'Map to target field',
  'pages.flexibleSingleImport.mapping.chooseSource': 'Choose source',
  'pages.flexibleSingleImport.mapping.step2MissingTitle':
    '{count} required fields are not mapped yet',
  'pages.flexibleSingleImport.mapping.step2MissingDescription':
    'Map these fields from the column selectors above:',
  'pages.flexibleSingleImport.mapping.step2CompleteTitle': 'All required fields are mapped',
  'pages.flexibleSingleImport.mapping.step2CompleteDescription':
    'You can complete step 2 and continue to check excluded rows.',
  'pages.flexibleSingleImport.mapping.step2MappedLabel': 'Mapped required fields:',
  'pages.flexibleSingleImport.mapping.advancedTitle': 'Step 4 · Set unmatched required fields',
  'pages.flexibleSingleImport.mapping.advancedHint':
    'Set a fixed value, sheet name, or file name here. If every row needs a different value and there is no source column, correct the workbook and upload it again.',
  'pages.flexibleSingleImport.mapping.requiredMissing': 'These required fields are not matched yet',
  'pages.flexibleSingleImport.mapping.requiredMissingDescription':
    'Only values shared by the whole sheet can be set here. If each row needs a different value and there is no source column, correct the original workbook and upload it again.',
  'pages.flexibleSingleImport.mapping.requiredComplete': 'All required fields are matched',
  'pages.flexibleSingleImport.mapping.requiredCompleteDescription':
    'If a missing value is different on every detail row, do not guess it here; correct the original workbook and upload it again.',
  'pages.flexibleSingleImport.mapping.parameter': 'Fixed value / parameter',
  'pages.flexibleSingleImport.mapping.transform': 'Transform',
  'pages.flexibleSingleImport.mapping.columnFallback': 'Column {column}',
  'pages.flexibleSingleImport.mapping.fixedPlaceholder': 'Enter a fixed value',
  'pages.flexibleSingleImport.mapping.regexPlaceholder': 'Regex, e.g. (\\d{4}-\\d{2})',
  'pages.flexibleSingleImport.mapping.datePlaceholder':
    'Supports yyyy-MM-dd, yyyy/MM, yyyy, or automatic detection',
  'pages.flexibleSingleImport.mapping.configuringSheet': 'Configuring sheet:',
  'pages.flexibleSingleImport.mapping.regenerate': 'Regenerate suggestions',
  'pages.flexibleSingleImport.mapping.suggestionAlert':
    'Suggestions are only a starting point. Confirm required fields and income fields before previewing.',
  'pages.flexibleSingleImport.mapping.previewFailed': 'Mapping preview failed',
  'pages.flexibleSingleImport.field.required': 'Required',
  'pages.flexibleSingleImport.field.saleMonth': 'Sale month',
  'pages.flexibleSingleImport.field.platform': 'Platform',
  'pages.flexibleSingleImport.field.country': 'Country / region',
  'pages.flexibleSingleImport.field.isrcNumber': 'ISRC / song ID',
  'pages.flexibleSingleImport.field.releaseType': 'Release type',
  'pages.flexibleSingleImport.field.saleType': 'Sale type',
  'pages.flexibleSingleImport.field.songTitle': 'Song title',
  'pages.flexibleSingleImport.field.currency': 'Currency',
  'pages.flexibleSingleImport.field.unitPrice': 'Unit price',
  'pages.flexibleSingleImport.field.netProfit': 'Net profit',
  'pages.flexibleSingleImport.field.reportMonth': 'Report month',
  'pages.flexibleSingleImport.field.brandName': 'Brand name',
  'pages.flexibleSingleImport.field.artistName': 'Artist name',
  'pages.flexibleSingleImport.field.publishTitle': 'Release title',
  'pages.flexibleSingleImport.field.upcNumber': 'UPC',
  'pages.flexibleSingleImport.field.publishListNumber': 'Release catalog number',
  'pages.flexibleSingleImport.field.streamSubscriptionType': 'Stream subscription type',
  'pages.flexibleSingleImport.field.saleNumber': 'Quantity',
  'pages.flexibleSingleImport.field.machineryCosts': 'Mechanical costs',
  'pages.flexibleSingleImport.field.totalIncome': 'Total income',
  'pages.flexibleSingleImport.field.customerShareRate': 'Customer share rate',
  'pages.flexibleSingleImport.field.albumName': 'Album name',
  'pages.flexibleSingleImport.field.playCount': 'Play count',
  'pages.flexibleSingleImport.source.column': 'Column',
  'pages.flexibleSingleImport.source.sheetName': 'Sheet name',
  'pages.flexibleSingleImport.source.fileName': 'File name',
  'pages.flexibleSingleImport.source.fixed': 'Fixed value',
  'pages.flexibleSingleImport.transform.none': 'None',
  'pages.flexibleSingleImport.transform.trim': 'Trim spaces',
  'pages.flexibleSingleImport.transform.regex': 'Regex extract',
  'pages.flexibleSingleImport.transform.date': 'Date conversion',
  'pages.flexibleSingleImport.transform.number': 'Number conversion',
  'pages.flexibleSingleImport.transform.integer': 'Integer conversion',
  'pages.flexibleSingleImport.transform.percent': 'Percentage conversion',
  'pages.flexibleSingleImport.preview.title': 'Preview result',
  'pages.flexibleSingleImport.preview.description':
    'Each selected sheet was rescanned using its data range and exclusion rules. Records are written to sales_list only after confirmation.',
  'pages.flexibleSingleImport.preview.sheet': 'Sheet',
  'pages.flexibleSingleImport.preview.consideredRows': 'Processed',
  'pages.flexibleSingleImport.preview.excludedRows': 'Excluded',
  'pages.flexibleSingleImport.preview.validRows': 'Valid',
  'pages.flexibleSingleImport.preview.invalidRows': 'Errors',
  'pages.flexibleSingleImport.preview.view': 'View',
  'pages.flexibleSingleImport.preview.samples': 'Samples',
  'pages.flexibleSingleImport.preview.mappingSamples': 'mapping samples',
  'pages.flexibleSingleImport.preview.rawValues': 'Raw values',
  'pages.flexibleSingleImport.preview.mappedValues': 'Mapped values',
  'pages.flexibleSingleImport.preview.errorCount': 'This sheet has {count} validation errors',
  'pages.flexibleSingleImport.preview.partialWarning':
    'Found {count} invalid rows. Valid rows can still be imported.',
  'pages.flexibleSingleImport.preview.partialWarningDescription':
    'Review the error details below. Invalid rows will be left out of this import and can be downloaded from the result page.',
  'pages.flexibleSingleImport.preview.errorTitle':
    'This sheet has {count} invalid rows; showing the first {shown}.',
  'pages.flexibleSingleImport.preview.errorDescription':
    'Each error includes the source row number, a readable reason, and key source values.',
  'pages.flexibleSingleImport.preview.errorReason': 'Error reason',
  'pages.flexibleSingleImport.preview.errorSource': 'Source row values',
  'pages.flexibleSingleImport.result.processed': 'Processed rows',
  'pages.flexibleSingleImport.result.inserted': 'Inserted',
  'pages.flexibleSingleImport.result.duplicates': 'Duplicates',
  'pages.flexibleSingleImport.result.errors': 'Errors',
  'pages.flexibleSingleImport.result.exportErrors': 'Download error rows',
  'pages.flexibleSingleImport.import.startFailed': 'Failed to start import',
  'pages.flexibleSingleImport.status.UPLOADED': 'Uploaded; awaiting configuration',
  'pages.flexibleSingleImport.status.READY': 'Configured; awaiting confirmation',
  'pages.flexibleSingleImport.status.IMPORTING': 'Importing',
  'pages.flexibleSingleImport.status.COMPLETED': 'Import completed',
  'pages.flexibleSingleImport.status.PARTIAL': 'Partially completed',
  'pages.flexibleSingleImport.status.FAILED': 'Import failed',
  'pages.flexibleSingleImport.status.CANCELLED': 'Cancelled',
  'pages.flexibleSingleImport.action.cancel': 'Cancel',
  'pages.flexibleSingleImport.action.importSheet': 'Import this sheet',
  'pages.flexibleSingleImport.action.skipSheet': 'Do not import this sheet',
  'pages.flexibleSingleImport.action.previousStep': 'Previous step',
  'pages.flexibleSingleImport.action.editStep': 'Edit',
  'pages.flexibleSingleImport.action.finishStep2': 'Complete step 2 and check excluded rows',
  'pages.flexibleSingleImport.action.finishStep3': 'Complete step 3 and fill unmatched fields',
  'pages.flexibleSingleImport.action.finishSheet':
    'Complete this sheet and continue to the next sheet',
  'pages.flexibleSingleImport.action.finishLastSheet':
    'Complete this sheet and preview all imported sheets',
  'pages.flexibleSingleImport.action.nextMapping': 'Next: field mapping',
  'pages.flexibleSingleImport.action.previousSheet': 'Previous sheet',
  'pages.flexibleSingleImport.action.nextSheet': 'Next sheet',
  'pages.flexibleSingleImport.action.previewAll': 'Preview all sheets selected for export',
  'pages.flexibleSingleImport.action.backToSheets': 'Back to sheet review',
  'pages.flexibleSingleImport.action.abandonImport': 'Abandon upload',
  'pages.flexibleSingleImport.action.continueImport': 'Continue import valid rows',
  'pages.flexibleSingleImport.action.previous': 'Previous',
  'pages.flexibleSingleImport.action.previewMapping': 'Preview mapping and validation',
  'pages.flexibleSingleImport.action.backEdit': 'Back to edit',
  'pages.flexibleSingleImport.action.confirmImport': 'Confirm import',
  'pages.flexibleSingleImport.action.close': 'Close',
};
